import { render, staticRenderFns } from "./catalogueMain.vue?vue&type=template&id=68b7b6bc&scoped=true"
import script from "./catalogueMain.vue?vue&type=script&lang=js"
export * from "./catalogueMain.vue?vue&type=script&lang=js"
import style0 from "./catalogueMain.vue?vue&type=style&index=0&id=68b7b6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7b6bc",
  null
  
)

export default component.exports